module.exports = __webpack_public_path__ + "img/card-back-blue.6b28f99c.svg";